module.exports = __webpack_public_path__ + "img/1M.9ea9a59d.jpg";